export default "__VITE_ASSET__ZIS4zXEu__"